import ScrollCarousel from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-blog-interrupter-carousel-viewport]',
  track: '[data-blog-interrupter-carousel-track]',
};

const carousels = [];

export default function () {
  // Check if there are more than one article slides
  if (document.querySelectorAll('.BlogMainInterrupterCarousel__article-slide').length <= 1) {
    return;
  }

  document.querySelectorAll('[data-blog-interrupter-carousel]').forEach((el) => {
    if (el.getAttribute('initialized') === 'true') {
      return;
    }

    // Slides moved inside the scroll track, so count them there.
    const track = el.querySelector(SELECTORS.track);
    if (!track || track.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    // Flickity defaults.
    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      prevNextButtons: true,
      pageDots: true,
      draggable: true,
      slidesPerView: 1,
      ariaLabel: 'Featured articles carousel',
    });

    carousels.push(carousel);
  });
}
